// Port of ios/Sources/ViewModels/ChannelMute.swift.
//
// Muting ONE conversation from its row (shared/API.md §8.3.2) — the rule both the quick action
// and every notification path read. Android's `ChannelMute` is the twin.
//
// A conversation is muted by either of two independent switches: its member row's
// `mark_unread == "mention"`, or its sidebar category's `muted` flag. Muted means silent: no
// notification, and no unread or mention badge in the sidebar (user ruling 2026-10-06).

/** The member-row value that mutes (`mention`) or unmutes (`all`). */
export function markUnread(muted: boolean): string {
  return muted ? 'mention' : 'all';
}

export function isMuted(markUnreadValue: string | null | undefined, inMutedCategory: boolean): boolean {
  return markUnreadValue === 'mention' || inMutedCategory;
}

/**
 * The single key the quick action sends. The server updates only the keys it is given, so
 * the reader's push level and desktop settings are untouched.
 */
export function notifyProps(muted: boolean): Record<string, string> {
  return { mark_unread: markUnread(muted) };
}

/** Namespace form, for `ChannelMute.isMuted(...)` call sites. */
export const ChannelMute = { markUnread, isMuted, notifyProps } as const;
